import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-park_tips",
  "use": "icon-park_tips-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-park_tips\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h28v28H0z\" /><path d=\"M23.333 19.833h2.334v2.334H2.333v-2.334h2.334v-8.166a9.333 9.333 0 1 1 18.666 0v8.166Zm-2.333 0v-8.166a7 7 0 0 0-14 0v8.166h14ZM10.5 24.5h7v2.333h-7V24.5Z\" fill=\"#FF6000\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol